module.exports = __webpack_public_path__ + "static/media/manage_departments_edit_department_name.29445f1a.mov";